import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/dashboard/Login';
import LandingPage from './components/dashboard/LandingPage';
import SearchPage from './components/dashboard/SearchPage';
import RegistrationReport from './components/dashboard/RegistrationReport';
import SendFollowUpEmail from './components/dashboard/SendFollowUpEmail';
import AddFamily from './components/dashboard/AddFamily';
import FamilyOverview from './components/dashboard/FamilyOverview';
import FamilyDetailsPage from './components/dashboard/FamilyDetailsPage';
import EditChild from './components/dashboard/EditChild';
import AddGuardian from './components/dashboard/AddGuardian';
import EditGuardian from './components/dashboard/EditGuardian';
import EditFamily from './components/dashboard/EditFamily';
import ExpiredRegistrationToken from './components/dashboard/ExpiredRegistrationToken';
import Layout from './Layout';
import { RegistrationContextProvider } from './components/signup/context/RegistrationContextProvider';
import AddChild from './components/dashboard/AddChild';
import UserAdminPage from './components/dashboard/UserAdminPage';

function AdminApp() {
  return (
    <RegistrationContextProvider>
      <BrowserRouter basename="/kidlab-reg/admin">
        <Routes>
          <Route element={<Layout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/landing-page" element={<LandingPage />} />
            <Route path="/add-child" element={<AddChild />} />
            <Route path="/search-page" element={<SearchPage />} />
            <Route
              path="/registration-report"
              element={<RegistrationReport />}
            />
            <Route
              path="/send-follow-up-email"
              element={<SendFollowUpEmail />}
            />
            <Route path="/add-family" element={<AddFamily />} />
            <Route path="/family-overview" element={<FamilyOverview />} />
            <Route
              path="/family-details-page"
              element={<FamilyDetailsPage />}
            />
            <Route path="/edit-child" element={<EditChild />} />
            <Route path="/add-guardian" element={<AddGuardian />} />
            <Route path="/edit-guardian" element={<EditGuardian />} />
            <Route path="/edit-family" element={<EditFamily />} />
            <Route
              path="/expired-registration-token"
              element={<ExpiredRegistrationToken />}
            />
            <Route path="/users" element={<UserAdminPage />} />
            <Route path="*" element={<LandingPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </RegistrationContextProvider>
  );
}

export default AdminApp;
